module.exports = __webpack_public_path__ + "img/avatar_bai.15e25f5e.png";